export default __webpack_public_path__ + "static/media/721.446599f1.png";